import { render, staticRenderFns } from "./CapturaFoto.vue?vue&type=template&id=f8777efe&scoped=true"
import script from "./CapturaFoto.vue?vue&type=script&lang=js"
export * from "./CapturaFoto.vue?vue&type=script&lang=js"
import style0 from "./CapturaFoto.vue?vue&type=style&index=0&id=f8777efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8777efe",
  null
  
)

export default component.exports